import { Accordion, AccordionItem } from "monday-ui-react-core";
import { useMemo } from "react";

import type { Command } from "@/services/runcli";

import { CommandList } from "./CommandList";
import type { CommandListProps } from "./CommandListProps";
import { EmptyCommandList } from "./EmptyCommandList";

export function GroupedCommandLists({ commands, onCopy }: CommandListProps) {
  const hasCommands = commands && commands.length > 0;
  const commandsByCategory = useMemo(() => partitionCommandsByCategory(commands), [commands]);
  const defaultIndex = useMemo(() => [0], []);

  if (!hasCommands) {
    return <EmptyCommandList />;
  }

  return (
    <Accordion allowMultiple={true} defaultIndex={defaultIndex}>
      {Object.keys(commandsByCategory).map((category, i) => (
        <AccordionItem key={i} title={category}>
          <CommandList commands={commandsByCategory[category]} onCopy={onCopy} />
        </AccordionItem>
      ))}
    </Accordion>
  );
}

function partitionCommandsByCategory(commands: Command[]): Record<string, Command[]> {
  const commandsByCategory: Record<string, Command[]> = {};
  commands.forEach((command) => {
    if (!commandsByCategory[command.category]) {
      commandsByCategory[command.category] = [];
    }
    commandsByCategory[command.category].push(command);
  });
  return commandsByCategory;
}
